import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const CardStyled = styled.div`
  background: var(--surface);
  border-radius: var(--radius-md);
  padding: 1rem;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border);
  border-left: 6px solid
    ${(props) =>
      props.status === "pendente"
        ? "var(--primary)"
        : props.status === "preparando"
          ? "#f59e0b"
          : "var(--secondary)"};

  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  animation: ${fadeIn} 0.3s ease-out;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: var(--shadow-md);
    transform: scale(1.01);
  }

  header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .user-info {
      strong {
        font-size: 1.1rem;
        color: var(--text-main);
        font-weight: 800;
      }
      .sub-info {
        display: flex;
        gap: 12px;
        margin-top: 4px;

        small,
        .whatsapp-link {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 0.8rem;
          color: var(--text-secondary);
          text-decoration: none;
        }

        .whatsapp-link:hover {
          color: var(--secondary);
        }
      }
    }

    .actions-header {
      display: flex;
      align-items: center;
      gap: 8px;

      .order-id {
        background: var(--background);
        padding: 4px 8px;
        border-radius: 6px;
        font-size: 0.7rem;
        font-family: monospace;
        font-weight: bold;
      }
    }
  }

  /* Melhoria visual na lista de itens */
  ul {
    background: #fdfdfd;
    padding: 0.5rem;
    border-radius: 8px;
    border: 1px dashed var(--border);
  }
`;

export const ItemsList = styled.ul`
  list-style: none;

  li {
    display: flex;
    gap: 10px;
    font-size: 0.9rem;
    padding: 3px 0;
    color: var(--text-main);

    .qty {
      color: var(--secondary);
      font-weight: 900;
      background: #e8f5e9;
      padding: 0 6px;
      border-radius: 4px;
      height: fit-content;
    }

    .name {
      display: flex;
      flex-direction: column;
      font-weight: 500;
    }
  }
`;

export const ActionButton = styled.button`
  width: 100%;
  margin-top: 10px;
  padding: 14px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-weight: 800;
  color: white;
  text-transform: uppercase;
  font-size: 0.85rem;
  transition: all 0.2s;

  background: ${(props) =>
    props.variant === "pendente"
      ? "var(--secondary)"
      : props.variant === "preparando"
        ? "#f59e0b"
        : "var(--primary)"};

  &:hover {
    filter: brightness(1.1);
    box-shadow: 0 4px 12px
      ${(props) =>
        props.variant === "pendente"
          ? "rgba(46, 204, 113, 0.3)"
          : "rgba(231, 76, 60, 0.3)"};
  }
`;

export const RefuseButton = styled.button`
  all: unset;
  cursor: pointer;
  padding: 6px;
  border-radius: 8px;
  color: #94a3b8;
  transition: all 0.2s;

  &:hover {
    background: #fee2e2;
    color: var(--primary);
  }
`;
